export const SectionDivider = () => (
  <div className="gold-divider" aria-hidden="true" />
);

export const Eyebrow = ({ children, testId }) => (
  <p
    data-testid={testId}
    className="text-[11px] sm:text-xs tracking-[0.32em] uppercase text-[#C9960C] font-medium mb-5"
  >
    {children}
  </p>
);
